module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"ProductAvailabileShippersList":{"heading":"Možnosti dopravy"}},"de":{"ProductAvailabileShippersList":{"heading":"Transportmöglichkeiten"}},"sk":{"ProductAvailabileShippersList":{"heading":"Možnosti dopravy"}}}')
  delete Component.options._Ctor
}
